module.exports = __webpack_public_path__ + "img/6-3.83e6b26a.png";